import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import logo from '../assets/logo-kernteam.png';
import './KernteamNavbar.css';

// Logo-Animation nur ein einziges Mal pro Sitzung (beim ersten Portal-Einstieg).
let logoIntroPlayed = false;

function KernteamNavbar() {
  const navigate = useNavigate();
  const location = useLocation();

  const animateLogoRef = useRef(
    Boolean(location.state && location.state.fromPortal) && !logoIntroPlayed
  );
  const animateLogo = animateLogoRef.current;

  useEffect(() => {
    if (animateLogo) logoIntroPlayed = true;
  }, [animateLogo]);

  const isPortalPage = location.pathname === '/' ||
    location.pathname.toLowerCase().startsWith('/kernteamportal');

  return (
    <div className={`navbar${isPortalPage ? ' navbar-portal' : ''}`}>

      <div className="logo logo-spotlight" onClick={() => navigate('/kernteamportal')}>
        <img
          src={logo}
          alt="Kernteam Logo"
          className={`logo-img ${animateLogo ? 'logo-img-animate' : ''} ${!isPortalPage ? 'logo-img-small' : ''}`}
        />
      </div>

      <div
        className="map-link"
        onClick={() => window.location.href = "/stadtplan"}
      >
          <span className="material-symbols-outlined map-icon">map</span>
      </div>

    </div>
  );
}

export default KernteamNavbar;
